import { errorHandler } from "./errorHandler";
import { UserData } from "../interface";
import { apiRequest } from "./apiRequest";

export const postUser = async (args: UserData): Promise<string> => {
  try {
    const data = await apiRequest<{ message: string }>("post", `/users`, {
      data: args,
    });

    return data.message;
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to create user");
  }
};
